// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"315":"ucare-panel-chunk","923":"ucare-widget-chunk"}[chunkId] || chunkId) + "." + {"46":"ea012d3b","315":"8d2b66dd","377":"33abea23","581":"89016043","829":"31edc10a","878":"56e7c1a9","913":"70222d82","923":"8b16d10e"}[chunkId] + ".chunk.js";
};